import 'core-js/stable';
import 'regenerator-runtime/runtime';

/* eslint-disable class-methods-use-this */

export default class VideoAbstract {
  constructor(el, options = {}) {
    const videoOptions = {
      provider: null,
      ...options,
    };

    if (this.constructor === VideoAbstract) {
      throw new Error('Abstract class can\'t be instantiated');
    }
    
    this.el = el;
    this.provider = videoOptions.provider;
    this.player = this.constructor.getPlayer(el);
    this.modal = el.closest('.modal');
  }

  init() {
    if (this.el.closest('.video-background')) {
      this.autoplay();
    }

    if (this.modal) {
      this.modalHandler();
    }
  }
  
  /**
   * Get player
   * 
   * @param {object} iframe
   * @abstract
   * @returns {object} player
   */
  static getPlayer(iframe) {
    return iframe;
  }

  /**
   * Autoplay video
   * 
   * @abstract
   */
  autoplay() {
    /* eslint-disable class-methods-use-this */
    throw new Error('Method \'autoplay()\' must be implemented.');
  }

  /**
   * Handle Bootstrap modal events
   */
  modalHandler() {
    $(this.modal).on('hidden.bs.modal', () => {
      this.stop();
    });

    $(this.modal).on('shown.bs.modal', () => {
      this.play();
    });
  }

  /**
   * Stop video
   * 
   * @abstract
   */
  stop() {
    /* eslint-disable class-methods-use-this */
    throw new Error('Method \'stop()\' must be implemented.');
  }

  /**
   * Play video
   * 
   * @abstract
   */
  play() {
    /* eslint-disable class-methods-use-this */
    throw new Error('Method \'play()\' must be implemented.');
  }
}
